<template>
  <calc-form-item :title-style="!isSpanBySpan ? 'inline' : 'block'">
    <template #title>
      <slot name="title"></slot>
      <template v-if="!$slots.title">
        {{ title }}
      </template>
    </template>

    <calc-number-input
      v-if="!isSpanBySpan"
      v-model="singleVal"
      addon="kN/m2"
      :min="0"
      :max="100"
    />

    <transition name="anim-slideX">
      <div v-if="isSpanBySpan">
        <div
          class="cantileverFieldRow cantileverFieldRow--1"
          v-if="calculation.input.hasCantilever"
        >
          <div class="fields_grid">
            <calc-number-input
              :label="`Consola 1`"
              v-model="spans[0]"
              addon="kN/m2"
              :min="0"
              :max="100"
            />
          </div>
        </div>

        <div class="fields_grid">
          <template v-for="(span, i) in spans">
            <calc-number-input
              v-if="
                !calculation.input.hasCantilever
                  ? true
                  : i !== 0 && i !== totalSpans - 1
              "
              v-model="spans[i]"
              :min="0"
              :max="100"
              :key="i"
              addon="kN/m2"
              :label="`${$t('Vão')} #${
                calculation.input.hasCantilever ? i : i + 1
              }`"
            />
          </template>
        </div>

        <div
          class="cantileverFieldRow cantileverFieldRow--2"
          v-if="calculation.input.hasCantilever"
        >
          <div class="fields_grid">
            <calc-number-input
              :label="`Consola 2`"
              addon="kN/m2"
              v-model="spans[totalSpans - 1]"
              :min="0"
              :max="100"
            />
          </div>
        </div>
      </div>
    </transition>
  </calc-form-item>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CalcFormItem from "./CalcFormItem";

export default {
  components: {
    CalcFormItem,
  },
  props: {
    title: {
      type: String,
      default: "Título por definir (prop.title)",
    },

    theCase: {
      type: String,
      required: true,
    },

    theType: {
      type: String,
      required: true,
    },

    limit: {
      type: [String, null],
      default: null,
    },

    // isMinMaxModeOn: {
    // 	type: [Boolean, null],
    // 	default: null,
    // },

    isSpanBySpan: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapState("calculator", ["calculation"]),

    ...mapGetters("calculator", ["load", "totalSpans"]),

    theLoad() {
      if (this.limit !== null) {
        return this.load(this.theCase, this.theType, this.limit);
      } else {
        return this.load(this.theCase, this.theType);
      }
    },

    theMinLoad() {
      if (this.limit === null) {
        return null;
      }

      return this.load(this.theCase, this.theType, "min");
    },

    theMaxLoad() {
      if (this.limit === null) {
        return null;
      }

      return this.load(this.theCase, this.theType, "max");
    },

    spans() {
      return this.theLoad.value;
    },

    minLoadSpans() {
      if (this.limit === null) {
        return null;
      }

      return this.theMinLoad.value;
    },

    maxLoadSpans() {
      if (this.limit === null) {
        return null;
      }

      return this.theMaxLoad.value;
    },

    singleVal: {
      get() {
        return this.spans[0];
      },

      set(val) {
        this.theLoad.value = Array(this.totalSpans).fill(val);
      },
    },

    // minLoadSingleVal() {
    // 	if (this.limit === null) {
    // 		return null;
    // 	}

    // 	return this.minLoadSpans[0];
    // },

    // maxLoadSingleVal() {
    // 	if (this.limit === null) {
    // 		return null;
    // 	}

    // 	return this.maxLoadSpans[0];
    // },

    // singleValMinVal() {
    // 	const defaultMin = 0;

    // 	if (this.limit === null || !this.isMinMaxModeOn) {
    // 		return defaultMin;
    // 	}

    // 	if (this.limit === "min") {
    // 		return defaultMin;
    // 	} else {
    // 		// limit === 'max'
    // 		return this.minLoadSingleVal;
    // 	}
    // },

    // singleValMaxVal() {
    // 	const defaultMax = 100;

    // 	if (this.limit === null || !this.isMinMaxModeOn) {
    // 		return defaultMax;
    // 	}

    // 	if (this.limit === "min") {
    // 		return this.maxLoadSingleVal;
    // 	} else {
    // 		// limit === 'max'
    // 		return defaultMax;
    // 	}
    // },
  },

  watch: {
    isSpanBySpan(val) {
      const { totalSpans, singleVal } = this;

      if (!val) {
        // SWITCH OFF
        this.theLoad.value = Array(totalSpans).fill(singleVal);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
